// Modules
import { decodeClid } from './decodeClid.js';
import { cutParamFromUrl } from './cutParamFromUrl.js';
import { handleMissingSid } from './handleMissingSid.js';
import { sendHit } from './utils/sendHit.js';

// Utils
import { debug } from './utils/debug.js';
import { COOKIE, URL } from '@iva/utils';

// Constants
import { ACTIONS, SID_COOKIE_NAME, PARAM_NAME, SID_BLACKLIST } from '../config.js';

/**
 * Matches SID with cookie and sends hit with action and returns action type as a string.
 * @param {String} sid - User's ID.
 * @return {('notstored' | 'same' | 'different')} Action based on context in browser.
 */
export const storeSid = (sid, reason) => {
  // get actual sid
  const localSidCookie = COOKIE.getCookie(SID_COOKIE_NAME);

  if (!localSidCookie) {
    // not stored sid, only linkdecoration SAVING COOKIE
    sendHit(ACTIONS.NOT_STORED);
    sendHit(reason, sid, true);
    handleMissingSid(sid);
    return ACTIONS.NOT_STORED;
  }
  if (localSidCookie === sid) {
    // both are same
    debug('"handleSid" found SID cookie with the same SID value');
    sendHit(ACTIONS.SAME);
    return ACTIONS.SAME;
  }
  debug('warn', `"handleSid" found SID cookie with different value from linkdec SID`);
  sendHit(ACTIONS.DIFFERENT, localSidCookie);
  return ACTIONS.DIFFERENT;
};

/**
 * Attempts to retrieve SID from UTM.
 * @return {String | null} SID or null if fail to parse or no sznclid in URL.
 */
export const getSid = () => {
  debug({
    message: 'getting SID',
    state: 'start',
  });

  const sznclid = cutParamFromUrl(window.location.href, PARAM_NAME);

  // blacklist
  const domain = URL.getDomainLevel(undefined, undefined, false);
  if (SID_BLACKLIST.includes(domain)) {
    debug(`SID handler stoped, domain "${domain}" is blacklisted.`);
    return null;
  }

  if (!sznclid) {
    debug({
      state: 'done',
      message: 'did not find sznclid, returning null',
      sznclid,
      error: 'no sznclid in URL',
    });
    return null;
  }

  debug(`found parameter "${PARAM_NAME}", decoding...`);
  const sid = decodeClid(sznclid);
  if (sid) {
    debug({ state: 'done', message: 'successfully retrieved "sid"', sid });
    return sid;
  }
  debug({ state: 'error', sid, sznclid, error: 'failed to decode sznclid' });
  return null;
};
